export default "__VITE_ASSET__d0bbc66f__"